import update from 'immutability-helper'
import _ from 'lodash'
import {
  PUT_SHARED_LINK,
  UPDATE_SALE_STAT_SETTINGS,
  FETCH_ANNOUNCEMENTS,
  FETCH_STATS_REPORTS,
  FETCH_SALE_STATS,
  FETCH_RANKINGS_STATS,
  FETCH_SERVICE_DESKS,
  FETCH_PROMOTIONS,
  FETCH_PROPOSAL_SUB_STATIONS
} from '../actions/actionTypes'
import DateHelper from '../lib/DateHelper'

const SALE_STAT_DEFAULT_DATE_PERIOD = DateHelper.getSaleStatDefaultPeriod()

const initialState = {
  sharedLink: {
    moreAnnouncements: '',
    supplierRanking: ''
  },
  announcements: [],
  serviceDesks: [],
  dashboard: {
    saleStat: {
      periodStart: SALE_STAT_DEFAULT_DATE_PERIOD.start,
      periodEnd: SALE_STAT_DEFAULT_DATE_PERIOD.end
    }
  },
  promotions: {
    SpHeaderTxt1: {},
    SpHeaderTxt2: {},
    SpHeaderTxt3: {},
    SpHomeRightImg1: {}
  },
  proposal: {
    subStations: []
  }
}

const serviceErrorReducer = (state, action) => {
  // service fail

  switch (action.type) {
    default:
      return state
  }
}

const serviceReducer = (state, action) => {
  // service error
  if (action.error) {
    return serviceErrorReducer(state, action)
  }

  switch (action.type) {
    case FETCH_ANNOUNCEMENTS:
      return update(state, { announcements: { $set: action.payload.announcements } })

    case FETCH_SERVICE_DESKS:
      return update(state, {
        serviceDesks: { $set: action.payload.serviceDesks }
      })

    case FETCH_PROMOTIONS: {
      const promotions = _.keyBy(action.payload.promotions, 'id', {})
      return update(state, { promotions: { $set: promotions } })
    }

    case FETCH_PROPOSAL_SUB_STATIONS: {
      return update(state, { proposal: { subStations: { $set: action.payload } } })
    }

    default:
      return state
  }
}

const reducer = (state, action) => {
  switch (action.type) {
    case PUT_SHARED_LINK:
      return update(state, { sharedLink: { $merge: action.payload } })
    case UPDATE_SALE_STAT_SETTINGS: {
      const { payload } = action
      if (_.isEmpty(payload)) {
        return state
      }
      return update(state, { dashboard: { saleStat: { $merge: payload } } })
    }
    default:
      return state
  }
}

const finalReducers = (state = initialState, action) => {
  switch (action.type) {
    case PUT_SHARED_LINK:
    case UPDATE_SALE_STAT_SETTINGS:
      return reducer(state, action)

    /** reservice reducer */
    case FETCH_ANNOUNCEMENTS:
    case FETCH_STATS_REPORTS:
    case FETCH_RANKINGS_STATS:
    case FETCH_SALE_STATS:
    case FETCH_SERVICE_DESKS:
    case FETCH_PROMOTIONS:
    case FETCH_PROPOSAL_SUB_STATIONS:
      return serviceReducer(state, action)

    default:
      return state
  }
}

export default finalReducers
